import { whyChooseUs } from "@/mocks/homeContent";

export default function ValueProposition() {
  return (
    <section className="relative py-16 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
            Why AllChinaBuySpreadsheet?
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            AllChinaBuySpreadsheet is a structured sourcing system that helps you find verified suppliers,
            compare prices, and make smarter buying decisions — no guessing, no unreliable listings.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}